import { Injectable } from '@angular/core';
import { IDeviceUtilService } from './iDeviceUtil.service';

@Injectable()
export class DeviceUtilService implements IDeviceUtilService {
  public getWindow(): Window {
    return window;
  }

  // like phone screen
  public isExtraSmallScreen(): boolean {
    return this.getWindow().innerWidth < 768;
  }

  // like tablet screen
  public isSmallScreen(): boolean {
    return !this.isMediumScreen() && this.getWindow().innerWidth >= 768;
  }

  // like desktop screen
  public isMediumScreen(): boolean {
    return !this.isLargeScreen() && this.getWindow().innerWidth >= 992;
  }

  // like wide desktop screen
  public isLargeScreen(): boolean {
    return this.getWindow().innerWidth >= 1200;
  }

  public isPortraite(): boolean {
    var win = this.getWindow();
    return win.innerWidth >= win.innerHeight;
  }

  public isLandscape(): boolean {
    var win = this.getWindow();
    return win.innerWidth < win.innerHeight;
  }
}
